import { memo } from 'react';
import { getIsSearchModalOpen } from '@bridebook/web/lib/search/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { getScreenType } from '@bridebook/web/lib/app/selectors';

const SearchModal = lazyComponent(() =>
  import('@bridebook/web/components/search/search-mobile/search-modal/search-modal').then(
    (mod) => mod.SearchModal,
  ),
);

const SearchByNameOrLocationModal = lazyComponent(
  () =>
    import(
      '@bridebook/web/components/search/search-desktop/search-by-name-or-location-modal/search-by-name-or-location-modal'
    ),
);

const SearchModalLazy = () => {
  const isModalOpen = useSelector(getIsSearchModalOpen);
  const { isDesktop } = useSelector(getScreenType);

  if (!isModalOpen) return null;

  return isDesktop ? <SearchByNameOrLocationModal /> : <SearchModal />;
};

export default memo(SearchModalLazy);
